import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/projects/components/dashboard-layout";
import { Card } from "@/projects/components/ui/card";
import { useAuth } from "@/projects/lib/useStore";

export const Route = createFileRoute("/admin/profile")({
  head: () => ({ meta: [{ title: "Profile — Admin" }] }),
  component: () => {
    const auth = useAuth();
    return (
      <DashboardLayout role="admin" title="Profile" breadcrumb={["Home", "Profile"]}>
        <Card className="max-w-xl p-6">
          <div className="flex items-center gap-4">
            <div className="grid h-16 w-16 place-items-center rounded-full gradient-hero text-xl font-bold text-white">{auth?.name?.[0]}</div>
            <div>
              <div className="text-lg font-semibold">{auth?.name}</div>
              <div className="text-sm capitalize text-muted-foreground">{auth?.role} · {auth?.id}</div>
            </div>
          </div>
          <div className="mt-6 grid gap-3 text-sm">
            <Row k="Email" v="admin@rajnagar.edu" />
            <Row k="Role" v="Super Admin" />
            <Row k="Event" v="રાજનગર જ્ઞાનોત્સવ 2.0" />
          </div>
        </Card>
      </DashboardLayout>
    );
  },
});

function Row({ k, v }: { k: string; v: string }) {
  return <div className="flex justify-between border-b py-2"><span className="text-muted-foreground">{k}</span><span className="font-medium">{v}</span></div>;
}
